<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">Cách vào màn hình [Thông tin học viên]</li>
                        <li @click="scrollToElement('vn-2')">Tìm kiếm học viên</li>
                        <li @click="scrollToElement('vn-3')">Xuất thành tích học viên</li>
                        <li @click="scrollToElement('vn-4')">Danh sách khóa học</li>
                    </ul>
                </div>
                <div id="vn-1">
                    <h1>1.Cách vào màn hình [Thông tin học viên]</h1>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào [Avatar] hoặc [Tên người dùng] để mở menu quản lý dành cho giáo viên.</p>
                    <p>② Khi nhấn vào mục [Thông tin học viên ] thì sẽ chuyển đến màn hình [Thông tin học viên] của các học viên tham gia khóa học mà giáo viên phụ trách</p>
                </div>
                <div id="vn-2">
                    <h1>2.Tìm kiếm học viên</h1>
                </div>
                <div>
                    <p>
                        <b><i>2.1 Tìm kiếm theo tên học viên</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-2.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào tab [Tên học viên]</p>
                    <p>② Nhập tên học viên muốn tìm kiếm</p>
                </div>
                <div>
                    <p>
                        <b><i>2.2 Tìm kiếm theo email</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-3.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào tab [Email]</p>
                    <p>② Nhập Email học viên muốn tìm kiếm</p>
                </div>
                <div id="vn-3">
                    <h1>3.Xuất thành tích học viên</h1>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-4.png" alt="" /></div>
                <div>
                    <p>Nhấn vào nút [Xuất thành tích học viên] để xuất file excel thành tích của học viên</p>
                </div>
                <div id="vn-4">
                    <h1>4.Danh sách khóa học</h1>
                </div>
                <div>
                    <p>
                        <b><i>4.1 Tìm kiếm khóa học</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-5.png" alt="" /></div>
                <div>
                    <p>① Nhập tiêu đề muốn tìm kiếm vào khung tìm kiếm</p>
                    <p>② Nhấn vào phân loại khóa học muốn tìm kiếm</p>
                    <p>③ Nhấn vào các nút để hiển thị hoặc không hiển thị các khóa học ứng với trạng thái</p>
                </div>
                <div>
                    <p>
                        <b><i>4.2 Chi tiết khóa học</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-6.png" alt="" /></div>
                <div>
                    <p>Nhấn vào khóa học cần xem nội dung chi tiết</p>
                </div>
                <div>
                    <p>
                        <b><i>4.3 Danh sách câu trả lời sai bài tập nhỏ</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-7.png" alt="" /></div>
                <div>
                    <p>Nhấn vào tỉ lệ điểm để xem danh sách câu sai bài tập nhỏ của học viên</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">Cách vào màn hình [Thông tin học viên]</li>
                        <li @click="scrollToElement('vn-2')">Tìm kiếm học viên</li>
                        <li @click="scrollToElement('vn-3')">Thông tin chi tiết học viên</li>
                        <li @click="scrollToElement('vn-4')">Danh sách khóa học</li>
                    </ul>
                </div>
                <div id="vn-1"><p>1. Cách vào màn hình [Thông tin học viên].</p></div>
                <div><p>① Nhán icon Menu ở phía dưới màn hình, thì thanh Menu như trên sẽ xuất hiện từ phía bên trái màn hình.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_student_1_1.png" alt="" /></div>
                <div><p>② Nhấn vào ô [Thông tin học viên] để di chuyển đến trang thông tin học viên.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_student_1_2.png" alt="" /></div>
                <div id="vn-2"><p>2. Tìm kiếm học viên.</p></div>
                <div><p>2.1. Tìm kiếm theo tên học viên.</p></div>
                <div><p>① Click icon [Tìm kiếm] .</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_student_2_1_1.png" alt="" /></div>
                <div><p>② Nhấn vào tab [Tên học viên].</p></div>
                <div><p>③ Nhập tên học viên muốn tìm kiếm.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_student_2_1_2.png" alt="" /></div>
                <div><p>2.2 Tìm kiếm theo email.</p></div>
                <div><p>① Click icon [Tìm kiếm].</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_student_2_2_1.png" alt="" /></div>
                <div><p>② Nhấn vào tab [Email].</p></div>
                <div><p>③ Nhập tên học viên muốn tìm kiếm.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_student_2_2_2.png" alt="" /></div>
                <div id="vn-3"><p>3. Thông tin chi tiết.</p></div>
                <div><p>① Chọn học viên cần xem.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_student_3_1.png" alt="" /></div>
                <div><p>② Hiểm thị thông tin học viên vừa chọn.</p></div>
                <div><p>● Tên học viên.</p></div>
                <div><p>● Giới tính.</p></div>
                <div><p>● Ngày tháng năm sinh.</p></div>
                <div><p>● Vai trò.</p></div>
                <div><p>● Thông tin liên lạc.</p></div>
                <div><p>● Cấp.</p></div>
                <div><p>● Lớp học trực thuộc: Lớp học viên đó đang tham gia.</p></div>
                <div><p>● Tổng số khóa học: Tổng khóa học mà học sinh đó đang tham gia.</p></div>
                <div><p>● Số khóa học chưa bắt đầu: Số khóa học học viên đó chưa tham gia.</p></div>
                <div><p>● Số khóa học đang học: Số khóa học học viên đó đang học.</p></div>
                <div><p>● Số khóa học đã kết thúc: Số khóa học mà học viên đó đã kết thúc khóa học.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_student_3_2.png" alt="" /></div>
                <div id="vn-4"><p>4. Danh sách khóa học.</p></div>
                <div><p>4.1 Tìm kiếm khóa học.</p></div>
                <div><p>① Nhập tiêu đề muốn tìm kiếm vào khung tìm kiếm.</p></div>
                <div><p>② Nhấn vào phân loại khóa học muốn tìm kiếm.</p></div>
                <div><p>③ Nhấn vào các nút để hiển thị hoặc không hiển thị các khóa học ứng với trạng thái.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_student_4_1_1.png" alt="" /></div>
                <div><p>4.2 Chi tiết khóa học.</p></div>
                <div><p>① Nhấn vào khóa học cần xem nội dung chi tiết.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_student_4_2_1.png" alt="" /></div>
                <div><p>② Hiển thị nội dung chi tiết học viên trong khóa học đó. Tại đây có thể xem được tiến độ của học viên, xem lịch sử dự thi của học viên trong khóa học đó và xem được học viên đã học nội dung và làm bài tập nào trong khóa học đó.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\manage_student_4_2_2.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/manageStudent_manual.vue